import { FC, ReactNode } from 'react'
import styles from 'components/features/pfm/CompetitiveAccounts/CompetitiveAccounts.styl'
import PercentageBadge from 'components/atoms/PercentageBadge'
import { AccountType, CompetitiveCategoryInterest } from 'interfaces/accounts'
import NoAccountsCopy from 'components/molecules/NoAccountsCopy'

type CompetitiveAccountsProps =
  & CompetitiveCategoryInterest
  & {
    type: AccountType
  }

export const CompetitiveAccounts: FC<CompetitiveAccountsProps> = (props) => {
  const { competitiveAccountsCount, allAccountsCount, type } = props

  const isAsset = type === 'assets'
  const V1 = isAsset ? 'asset' : 'debt'
  const V2 = isAsset ? 'earn' : 'save'
  const V3 = isAsset ? 'earning' : 'paying'
  let text: ReactNode

  if (allAccountsCount === 0) {
    text = (
      <NoAccountsCopy type={ type } standalone={ false } />
    )
  } else if (allAccountsCount === 1) {
    text = competitiveAccountsCount === allAccountsCount
      ? `The interest rate you're ${ V3 } on your ${ V1 } account is competitive compared with your peers. Well done!`
      : `The interest rate you're ${ V3 } on your ${ V1 } account is not competitive compared with your peers. You can do better!`
  } else {
    if (competitiveAccountsCount === allAccountsCount) {
      text = `The interest rates you're ${ V3 } on all of your ${ V1 } accounts are competitive compared with your peers. That's great!`
    } else if (competitiveAccountsCount === 1) {
      text = `The interest rate you're ${ V3 } on 1 out of your ${ allAccountsCount } ${ V1 } accounts is competitive. You could ${ V2 } more.`
    } else if (competitiveAccountsCount > 1) {
      text = `The interest rates you're ${ V3 } on ${ competitiveAccountsCount } out of your ${ allAccountsCount } ${ V1 } accounts are competitive. You could ${ V2 } more.`
    } else {
      text = `The interest rates you're ${ V3 } on your ${ V1 } accounts are not competitive compared with your peers. You can do better!`
    }
  }

  return (
    <div className={ styles.competitiveAccounts }>
      <PercentageBadge { ...props } strokeWidth={ 6 } strokeEnabled warningTheme />
      <div className={ styles.competitiveAccountsSummary }>
        { text }
      </div>
    </div>
  )
}

